import { useContext, useEffect } from 'react';

import { MapContext } from '../MapContext';
import { mapPulseAnimation } from '../utils/mapCommon';
import { kMonitorRouteBorderLayerId } from '../utils/map_constants';

interface UseHoverPulseAnimationOptions {
  hasData: boolean;
  shouldStopAnimation: boolean;
}

//  hook to manage pulsing animation for hovered route borders.
export function useHoverPulseAnimation({
  hasData,
  shouldStopAnimation,
}: UseHoverPulseAnimationOptions) {
  const { refMap, mapReady, refStyleReady } = useContext(MapContext);

  useEffect(() => {
    if (!hasData || !refMap.current || !refStyleReady.current || !mapReady) {
      return () => {};
    }

    const stopAnimation = mapPulseAnimation(
      refMap.current,
      kMonitorRouteBorderLayerId,
    );

    // Stop animation if condition is met
    if (shouldStopAnimation) {
      stopAnimation?.();
    }

    return () => {
      stopAnimation?.();
    };
  }, [mapReady, hasData, shouldStopAnimation, refMap, refStyleReady]);
}
